import { addWeeks } from "date-fns";

export enum AlarmScheduleUnitEnum {
    Hour = 1,
    Day = 2,
    Week = 3,
    Month = 4,
    Year = 5
}

export enum DayOfWeekEnum {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
}

export interface IAlarmScheduleLinkedAlarmSchemeModel {
    id: number;
    name: string;
}


export interface IBlackoutSchedule {
    daysOfWeek: number[] | undefined; // empty is every day
    startHour: string | undefined;
    endHour: string | undefined;
}

export interface IAlarmScheduleModel {
    id: number;
    name: string;
    start: Date;
    end: Date;
    duration: number;
    durationUnit: AlarmScheduleUnitEnum;
    repeatInterval: number;
    repeatIntervalUnit: AlarmScheduleUnitEnum;
    linkedAlarmSchemes: IAlarmScheduleLinkedAlarmSchemeModel[];
    timezone: string;
    olsonTimezone: string;

    blackoutSchedules: IBlackoutSchedule[] | undefined;
}


const defaultAlarmSchedule: IAlarmScheduleModel = {
        id: -1,
        name: '',
        start: new Date(),
        end: addWeeks(new Date(), 1),
        duration: 1,
        durationUnit: AlarmScheduleUnitEnum.Week,
        repeatInterval: 3,
        repeatIntervalUnit: AlarmScheduleUnitEnum.Week,
        linkedAlarmSchemes: [],
        timezone: '',
        olsonTimezone: '',
        blackoutSchedules: undefined
}

export {defaultAlarmSchedule}
